<template>
  <div class="text-center">
    <!-- <app-social></app-social> -->
    <!-- <div class="home">
      <a href="https://www.hozehkh.com" style="display: block">
        <img class="logo" :src="require(`../../assets/logo.jpg`)" />
      </a>
      به سامانه جدید پورتال طلاب (تغذیه) خوش آمدید.
      <br />
      <div style="font-size: 16px; margin-top: 10px">نسخه آزمایشی</div>
    </div>
    <v-btn color="primary white--text" rounded @click="handleOpenID"
      >ورود از طریق درگاه حوزه</v-btn
    >
    <div class="footerAddress">
      <div class="itText">
        دفتر فناوری اطـلاعات مرکز مدیریت حـوزه علمیه خراســان
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  
  created() {
    this.handleOpenID();
  },
  methods: {
    /**
     * open login page
     */
    handleOpenID() {
      var url = process.env.VUE_APP_API_ENDPOINT ;
      window.location.href = url;
    },
  },
};
</script>
<style scoped>
.home {
  text-align: center;
  color: black;
  padding: 20px 0;
  font-size: 24px;
}
.footerAddress {
  position: fixed;
  bottom: 0;
  z-index: 2;

  width: 100%;
  text-align: right;
  line-height: 2;
  text-align: justify;
  color: white;
  background-color: darkslategrey;
  padding: 15px;
}

.itText {
  color: lightgray;
  text-align: center;

  font-size: 13px;
}

.logo {
  width: 150px;
  height: 200px;
}
</style>
